const baseUrls = {
  version: 'v1.0.1',

  list: {
    baseHref: 'home/',
    baseUrlVersion: '/v1',

    apiBaseUser: '/auth',
    apiEntityLogin: '/login',

    apiEntityResetPassword: '/reset-password',
    apiEntityForgotPassword: '/forgot-password',
    apiEntityRefreshToken: '/refresh-token',

    apiEntityUser: '/user',
    apiEntityUserRole: '/role',
    apiEntityRegister: '/register',

    apiDashboard: '/dashboard',
    apiDashboardBalancePosition: '/posicion-inicial',
    apiDashboardDailyPosition: '/posicion-diaria',
    apiDashboardLatestAuditedBalances: '/ultimos-saldos-arqueados',
    apiDashboardUnassignedOperations: '/unassigned-operations',
    apiDashboardRealBalances: '/saldos-arqueados',
    apiDashboardRealBalancesByCurrency: '/saldos-arqueados/moneda',
    apiDashboardRealBalancesByCurrencyLocation: '/saldos-arqueados/moneda-ubicacion',
    apiDashboardRealBalancesByTag: '/saldos-arqueados/etiqueta',
    apiDashboardBalancesReceivablePayable: '/saldos',
    apiDashboardProfitability: '/rentabilidad',
    apiDashboardServicePpp: '/ppp-por-servicio',

    apiLocation: '/location',

    apiTag: '/label',

    apiEntity: '/entity',
    apiEntityConfig: '/configuration',
    apiEntityCustomer: '/customer',
    apiEntityProvider: '/provider',
    apiEntityAgent: '/commission-agent',
    apiEntityBroker: '/broker',
    apiRelationBroker: '/relation/broker',

    apiOperation: '/operation',
    apiCommissionConfig: '/commission-config',
    apiOperationBenefit: '/service',
    apiOperationType: '/type',
    apiOperationReason: '/reason',
    apiTransaction: '/buying-or-selling-currency',
    apiOperationBank: '/bank',
    apiOperationCheck: '/check-discount',
    apiOperationEcheq: '/e-check-discount',
    apiOperationCable: '/cable',
    apiCableRequests: '/solicitudes',
    apiCableRequestsByType: '/tipo',
    apiCableProviderRequests: '/proveedor',
    apiOperationCrypto: '/cripto',
    apiCryptoRequests: '/solicitudes',
    apiCryptoRequestsByType: '/tipo',
    apiCryptoProviderRequests: '/proveedor',
    apiOperationCheckingAccount: '/account-balance',
    apiOperationCheckingAccountLast: '/rg-last-balance-amount',
    apiEntityTransfer: '/entity-transfer',
    apiInvoice: '/invoice',
    apiOperationCollectorAccount: '/collection-account',
    apiOperationHistoryService: '/history-service',
    apiOperationCashFlow: '/cash-flow',

    apiCurrency: '/currency',

    apiInternal: '/internal',
    apiInternalIncomeExpenses: '/income-expenses',

    apiStock: '/stock',
    apiCurrencyAudit: '/cash-reconciliation',
    apiCurrencyAuditConfirmation: '/confirmation-cash-reconciliation',
  },
} as const;

export default baseUrls;
